<script setup lang="ts">
import useProductStore from '@/stores/product'
import { AppDrawer } from 'lilasia-ui'
import PurchaseOptions from './PurchaseOptions.vue'

const productStore = useProductStore()
</script>

<template>
  <AppDrawer
    v-model="productStore.showPurchaseOptions"
    position="bottom"
    backdrop
  >
    <div class="w-dvw">
      <PurchaseOptions />
    </div>
  </AppDrawer>
</template>
